import React from 'react';
import './styles.scss';

interface IErrorMessageProp {
  title?: Nullable<string>;
  message: string;
}

const ErrorMessage = ({ title, message }: IErrorMessageProp) => {
  return (
    <div styleName="error-wrapper">
      <span>{`${title || 'Error'}: ${message}`}</span>
    </div>
  );
};

export default ErrorMessage;
